import { Team, User, UnnamedResource, JobRole } from "../../../../normalizr/entities";
import { ItemAdditionalOptions } from "../../../list/BaseList";
import { ResourceGroup } from "./UserGroups";

export type Resource = Partial<User> &
    Partial<UnnamedResource> &
    Team &
    JobRole &
    ResourceGroup &
    ItemAdditionalOptions & {
        itemId?: string;
    };

export type SingleSelectProps = SelectionProps<Single>;
export type MultiSelectProps = SelectionProps<Multiple>;

export type Single = false;
export type Multiple = true;
export type SelectMode = Single | Multiple;

export type SelectionProps<TMode extends SelectMode = SelectMode> = {
    multiple?: TMode;
    selected: TMode extends Multiple ? SelectedId[] : number | string | SelectedId;
    onChange: TMode extends Multiple ? F1<SelectedId[], void> : F1<Resource, void>;
    onChangeAuditEvent?: TMode extends Multiple ? string : null;
    onCancel?: TMode extends Multiple ? F : null;
    required?: boolean;
};

export const isUser = (item: Resource): item is User => !!item.UserId;
export const isTeam = (item: Resource): item is Team => !!item.Users;
export const isUnnamed = (item: Resource): item is UnnamedResource => !!item.UnnamedResourceId;

export const areResourceEqual = (item: Resource, newItem: Resource) =>
    item.UserId === newItem.UserId &&
    item.UnnamedResourceId === newItem.UnnamedResourceId &&
    item.itemId === newItem.itemId;

export type SelectedId<T = number | string> = {
    id: T;
    isUnnamedResource?: boolean;
};
